/** @format */
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { KitModelRow } from '../kit-model-row';
import { DEFAULT_TEST_ID } from './config/constants';
import { KitCardProps, StyledKitCardProps } from './config/types';
import { styles } from './kit-card.styles';

export * from './config/constants';
export type { KitCardProps } from './config/types';

const StyledKitCard = styled.div<StyledKitCardProps>`
    ${styles}
`;

/**
 * One theme of kit, as a pink header bar naming it and carrying its own
 * stat, on top of a body naming the kit itself. The two tall cards and the
 * wide card are this same component under different layouts, not separate
 * components, so the shared bar can't drift between them.
 */
export const KitCard: FunctionComponent<KitCardProps> = ({
    card,
    layout,
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    ...otherProps
}) => {
    const { heading, blurb, stat, models } = card;

    return (
        <StyledKitCard
            $layout={layout}
            // eslint-disable-next-line @mpb-com/mpb/transient-props-last -- Legacy code: do not use as an example.
            data-testid={dataTestId}
            {...otherProps}
        >
            <div className="kit-card-bar">
                <span className="kit-card-heading">{heading}</span>
                <span
                    className="kit-card-stat"
                    data-testid={`${dataTestId}__stat`}
                >
                    <span className="kit-card-stat-value">{stat.value}</span>
                    <span className="kit-card-stat-label">{stat.label}</span>
                </span>
            </div>
            <div className="kit-card-body">
                <p className="kit-card-blurb">{blurb}</p>
                <ul className="kit-card-models">
                    {models.map((model, index) => (
                        <KitModelRow
                            key={model.id}
                            model={model}
                            data-testid={`${dataTestId}__model-${index}`}
                        />
                    ))}
                </ul>
            </div>
        </StyledKitCard>
    );
};
